import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { ButtonConfig } from 'src/app/models/button.component.model';

@Component({
  selector: 'app-warning-dialog',
  templateUrl: './warning-dialog.component.html',
  styleUrls: ['./warning-dialog.component.scss']
})
// tslint:disable-next-line:component-class-suffix
export class WarningDialog implements OnInit {
  public confirmMessage: string;
  public newIconClass: string;
  iconClass = 'Bosch-Ic-notification-warning';
  buttonConfig = [new ButtonConfig('Cancel', false, true, () => this.close(false))];
  constructor(public dialogRef: MatDialogRef<WarningDialog>) {
  }
  ngOnInit() {
    if (this.newIconClass !== undefined && this.newIconClass !== '') {
      this.iconClass = this.newIconClass;
    }
  }
  close(confirm: boolean) {
    this.dialogRef.close(confirm);
  }
}
